// Saverium.es language specific routes (not brand, one brand can have multiple languages)
import es from './es'
import en from './en'

export const routes = {
  es,
  en,
}
